// TODO via php to not flicker on load?
import { Cookie } from "@modules/util/Cookie"

export enum Themes {
    Default = "default",
    HighContrast = "high-contrast",
}

export function setTheme(theme: Themes) {
    if (!Object.values(Themes).includes(theme)) {
        return
    }

    document.documentElement.classList.remove(getTheme())
    themeCookie().value = theme
    updateDocumentTheme()
}

export function getTheme() {
    const theme = themeCookie().value || Themes.Default
    if (!Object.values(Themes).includes(theme)) {
        return Themes.Default
    }
    return themeCookie().value || Themes.Default
}

export function updateDocumentTheme() {
    document.documentElement.classList.add(getTheme())
}

function themeCookie() {
    return new Cookie("theme", {
        path: "/",
        domain: SiteInfo.cookieDomain,
    })
}

const switchElements = document.querySelectorAll<HTMLInputElement>(
    ".high-contrast-switch-dark, .high-contrast-switch-light",
)
const isHighContrast = themeCookie().value === Themes.HighContrast
for (let i = 0; i < switchElements.length; i++) {
    switchElements[i].addEventListener("change", () => {
        setTheme(switchElements[i].checked ? Themes.HighContrast : Themes.Default)

        // sync other switches
        for (let j = 0; j < switchElements.length; j++) {
            switchElements[j].checked = switchElements[i].checked
        }
    })
    switchElements[i].checked = isHighContrast
}

updateDocumentTheme()
